<form class="form-group flex column filter-form" [formGroup]="form" *ngIf="form">
  <div class="field flex column">
    <mat-label class="field-label">{{ "Filter.Form.Status" | translate }}</mat-label>
    <mat-form-field appearance="outline" class="form-control-full-width">
      <mat-select formControlName="status">
        <mat-option [value]="sharedConstants.ALL">{{ 'Options.ALL' | translate }}</mat-option>
        <mat-option *ngFor="let item of requestHistoryStatus | enumToArray" [value]="item.value">
          {{ 'Enum.RequestHistoryStatus.' + item.value | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field flex column">
    <mat-label class="field-label">{{ "Filter.Form.Action" | translate }}</mat-label>
    <mat-form-field appearance="outline" class="form-control-full-width">
      <mat-select formControlName="action">
        <mat-option [value]="sharedConstants.ALL">{{ 'Options.ALL' | translate }}</mat-option>
        <mat-option *ngFor="let item of requestHistoryAction | enumToArray" [value]="item.value">
          {{ 'Enum.RequestHistoryAction.' + item.value | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field flex column">
    <mat-label class="field-label">{{ "Filter.Form.From" | translate }}</mat-label>
    <mat-form-field appearance="outline" class="form-control-full-width">
      <mat-select formControlName="from">
        <mat-option [value]="sharedConstants.ALL">{{ 'Options.ALL' | translate }}</mat-option>
        <mat-option *ngFor="let item of requestCreatedByType | enumToArray" [value]="item.value">
          {{ 'Enum.RequestCreatedByType.' + item.value | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field flex column">
    <mat-label class="field-label">{{ "Filter.Form.To" | translate }}</mat-label>
    <mat-form-field appearance="outline" class="form-control-full-width">
      <mat-select formControlName="to">
        <mat-option [value]="sharedConstants.ALL">{{ 'Options.ALL' | translate }}</mat-option>
        <mat-option *ngFor="let item of requestCreatedByType | enumToArray" [value]="item.value">
          {{ 'Enum.RequestCreatedByType.' + item.value | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex column">
    <mat-label class="field-label">{{ "Filter.Form.RequestUrl" | translate }}</mat-label>
    <app-search-input
      iconPosition="right"
      placeholder="{{ 'Placeholder.Search' | translate }}"
      [showSearchActions]="false"
      formControlName="requestUrl"
    ></app-search-input>
  </div>

  <div class="flex column mt-7">
    <mat-label class="field-label">{{ "Filter.Form.CreatedAt" | translate }}</mat-label>
    <app-date-range showIcon="true" formControlName="dateRangeType" [showCustomDateOption]="true"></app-date-range>
  </div>
</form>
